import { useQuery } from '@tanstack/react-query';
import { auditApi } from 'App';

export function useTargetRegions(session: string) {
  return useQuery(['target regions', session], () => auditApi.getTargetRegions(session));
}
